<template>
  <div>
    <el-card shadow="hover">
      <template slot="header">
        <div class="clearfix">
          <span>操作日志</span>
          <div style="float: right">
            <el-button type="success" size="small" icon="el-icon-download" @click="handleExport">导出日志</el-button>
          </div>
        </div>
      </template>
      <el-form :inline="true" :model="searchForm" class="mb-4">
        <el-form-item label="操作人">
          <el-input v-model="searchForm.userName" placeholder="请输入操作人" style="width: 180px" @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="操作类型">
          <el-select v-model="searchForm.operationType" placeholder="请选择类型" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="新增" value="新增"></el-option>
            <el-option label="修改" value="修改"></el-option>
            <el-option label="删除" value="删除"></el-option>
            <el-option label="审批" value="审批"></el-option>
            <el-option label="出库" value="出库"></el-option>
            <el-option label="入库" value="入库"></el-option>
            <el-option label="导入" value="导入"></el-option>
            <el-option label="导出" value="导出"></el-option>
            <el-option label="登录" value="登录"></el-option>
            <el-option label="操作" value="操作"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="logList" style="width: 100%" stripe>
        <el-table-column prop="userName" label="操作人" width="120"></el-table-column>
        <el-table-column prop="operationType" label="操作类型" width="100">
          <template slot-scope="scope">
            <el-tag :type="getTypeColor(scope.row.operationType)" size="small">{{ scope.row.operationType }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作内容" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ formatContent(scope.row.operationContent) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operationDevice" label="操作设备" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ip" label="IP地址" width="130"></el-table-column>
        <el-table-column prop="createTime" label="操作时间" width="170"></el-table-column>
        <el-table-column prop="id" label="ID" width="70"></el-table-column>
        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <template v-if="isImportAction(scope.row)">
              <el-tag v-if="isReverted(scope.row)" type="info" size="mini">已撤销</el-tag>
              <el-button
                v-else
                type="danger"
                size="mini"
                icon="el-icon-refresh-left"
                :loading="revertingBatch === getBatchNo(scope.row)"
                @click="handleRevert(scope.row)"
              >撤销导入</el-button>
            </template>
            <span v-else style="color: #c0c4cc">-</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-4">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { logApi, legacyImportApi, giftRecipientApi } from '../api/api'

export default {
  data() {
    return {
      logList: [],
      batchesMap: {},
      revertingBatch: '',
      searchForm: { userName: '', operationType: '' },
      currentPage: 1,
      pageSize: 20,
      total: 0
    }
  },
  mounted() {
    this.loadBatches()
    this.getLogList()
  },
  methods: {
    loadBatches() {
      const p1 = legacyImportApi.getBatches().catch(() => ({ data: [] }))
      const p2 = giftRecipientApi.getBatches().catch(() => ({ data: [] }))
      Promise.all([p1, p2]).then(([r1, r2]) => {
        const map = {}
        ;(r1.data || []).forEach(b => {
          if (b.batchNo) map[b.batchNo] = b
        })
        ;(r2.data || []).forEach(b => {
          if (b.batchNo) map[b.batchNo] = b
        })
        this.batchesMap = map
      })
    },
    getLogList() {
      logApi.getLogPage(this.currentPage, this.pageSize, this.searchForm).then(res => {
        this.logList = res.data.records || []
        this.total = res.data.total || 0
      })
    },
    formatContent(content) {
      if (!content) return ''
      if (content.includes('导入旧客户档案') || content.includes('原系统客户导入')) {
        if (content.includes('试运行') || content.includes('预览')) {
          return '客户管理 - 原系统客户导入（试运行/预览）'
        }
        if (content.includes('撤销')) {
          return '客户管理 - 撤销原系统客户导入'
        }
        return '客户管理 - 原系统客户导入'
      }
      if (content.includes('礼品名单') || content.includes('GiftRecipient')) {
        if (content.includes('预检') || content.includes('预览')) {
          return '礼品名单管理 - 批量导入预检'
        }
        if (content.includes('撤销')) {
          return '礼品名单管理 - 撤销礼品名单导入'
        }
        return '礼品名单管理 - 批量导入礼品名单'
      }
      return content
    },
    getBatchNo(row) {
      if (!row || !row.operationContent) return null
      const content = String(row.operationContent)
      if (content.includes('试运行') || content.includes('预览') || content.includes('撤销') || content.includes('预检')) return null

      const bracketMatch = content.match(/\[批次:\s*([^\]]+)\]/)
      if (bracketMatch && bracketMatch[1]) return bracketMatch[1].trim()

      const matchLgi = content.match(/LGI\d{14}[A-Z0-9]{4}/)
      if (matchLgi) return matchLgi[0]

      const matchGri = content.match(/GRI\d{14}[A-Z0-9]{4}/)
      if (matchGri) return matchGri[0]

      if (content.includes('导入旧客户档案') || content.includes('原系统客户导入') || content.includes('礼品名单')) {
        const logTime = new Date(row.createTime).getTime()
        const found = Object.values(this.batchesMap).find(b => {
          if (!b.createTime) return false
          const bTime = new Date(b.createTime).getTime()
          return Math.abs(bTime - logTime) < 15000
        })
        if (found) return found.batchNo
      }
      return null
    },
    isImportAction(row) {
      if (!row) return false
      const content = row.operationContent || ''
      const isLegacy = (content.includes('原系统客户导入') || content.includes('导入旧客户档案'))
      const isGift = (content.includes('礼品名单') && (content.includes('导入') || content.includes('import')))
      return (isLegacy || isGift) && !content.includes('试运行') && !content.includes('预览') && !content.includes('撤销') && !content.includes('预检') && !!this.getBatchNo(row)
    },
    isGiftRecipientImport(row) {
      if (!row) return false
      const content = row.operationContent || ''
      return content.includes('礼品名单') && (content.includes('导入') || content.includes('import'))
    },
    isLegacyImport(row) {
      if (!row) return false
      const content = row.operationContent || ''
      return (content.includes('原系统客户导入') || content.includes('导入旧客户档案'))
    },
    isReverted(row) {
      const batchNo = this.getBatchNo(row)
      if (!batchNo) return false
      const batch = this.batchesMap[batchNo]
      return batch && batch.status === 0
    },
    handleRevert(row) {
      const batchNo = this.getBatchNo(row)
      if (!batchNo) return
      const isGift = this.isGiftRecipientImport(row)
      const title = isGift ? '撤销礼品名单导入确认' : '撤销导入确认'
      const msg = isGift
        ? `确定要撤销该次礼品名单导入吗？<br/>
<span style="color:#f56c6c;font-size:12px">此操作将删除本次导入新建的礼品名单记录，并恢复合并前的数据！</span><br/><br/>
<div style="padding:8px 10px;background:#fdf6ec;border-left:3px solid #e6a23c;border-radius:3px;color:#e6a23c;font-size:12px;line-height:1.5">
  <strong>🔔【重要业务影响提示】</strong><br/>
  若名单中的人员在导入后已办理过<strong>「出库」</strong>：撤销后可能影响历史出库记录中的人员档案关联与后续数据统计核对。
</div>`
        : `确定要撤销该次原系统客户导入吗？<br/>
<span style="color:#f56c6c;font-size:12px">此操作将删除本次导入新建的客户档案、销售订单及历史出库记录，恢复到导入前的数据！</span><br/><br/>
<div style="padding:8px 10px;background:#fef0f0;border-left:3px solid #f56c6c;border-radius:3px;color:#f56c6c;font-size:12px;line-height:1.5">
  <strong>🔔【重要业务影响提示】</strong><br/>
  • 若该批次客户在导入后，业务员/客户已发起过<strong>「出库」</strong>（如新出库、送存货、尊贵卡等）：撤销将导致后续出库记录脱节、卡内剩余额度异常、存货台账混乱！<br/>
  • 若已产生后续回款、签字或欠款变更：撤销将影响财务与客户账目一致性。
</div>`

      this.$confirm(msg, title, {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定撤销',
        cancelButtonText: '取消',
        confirmButtonClass: 'el-button--danger',
        type: 'warning'
      }).then(() => {
        this.revertingBatch = batchNo
        const revertPromise = isGift ? giftRecipientApi.revert(batchNo) : legacyImportApi.revert(batchNo)
        revertPromise.then(res => {
          if (res.data && res.data.success) {
            this.$message.success(res.data.message || '撤销成功')
            this.getLogList()
            this.loadBatches()
          } else {
            this.$message.error((res.data && res.data.message) || '撤销失败')
          }
        }).catch(err => {
          const errMsg = (err.response && err.response.data && err.response.data.message) || '撤销失败'
          this.$message.error(errMsg)
        }).finally(() => {
          this.revertingBatch = ''
        })
      }).catch(() => {})
    },
    handleSearch() { this.currentPage = 1; this.getLogList() },
    resetSearch() {
      this.searchForm = { userName: '', operationType: '' }
      this.handleSearch()
    },
    handleSizeChange(size) { this.pageSize = size; this.getLogList() },
    handleCurrentChange(page) { this.currentPage = page; this.getLogList() },
    getTypeColor(type) {
      const map = {
        '新增': 'success', '修改': '', '删除': 'danger',
        '审批': '', '出库': 'warning', '入库': 'success',
        '导入': 'warning', '导出': 'warning', '登录': 'info', '操作': 'info'
      }
      return map[type] || 'info'
    },
    handleExport() {
      const headers = ['ID', '操作人', '操作类型', '操作内容', '操作设备', 'IP地址', '操作时间']
      const fields = ['id', 'userName', 'operationType', 'operationContent', 'operationDevice', 'ip', 'createTime']
      let csv = '\uFEFF' + headers.join(',') + '\n'
      this.logList.forEach(row => {
        csv += fields.map(f => '"' + (row[f] || '') + '"').join(',') + '\n'
      })
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = '操作日志_' + new Date().toISOString().slice(0, 10) + '.csv'
      link.click()
    }
  }
}
</script>

<style scoped>
.mb-4 { margin-bottom: 16px; }
.mt-4 { margin-top: 16px; }
.clearfix { display: flex; align-items: center; justify-content: space-between; }
</style>
